import { Component, OnInit } from '@angular/core';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.css']
})
export class ForgotpasswordComponent implements OnInit {

  forgotPasswordForm: FormGroup;
  isResetError = false;
  resetMsg = "";
  resetService_: any;

  constructor(public resetService: UseraccessserviceService, private router: Router, private toastr: ToastrService, private headerinfo: ComponentheaderService, private schoolService: SchoolmanagementService) {
    this.resetService_ = resetService;
    this.forgotPasswordForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
    });
  }

  updateLoadScreen(val: boolean) {
    this.resetService.isLoading = val;
    if (val) {
      this.forgotPasswordForm.disable();
    } else {
      this.forgotPasswordForm.enable();
    }
  }

  async OnSubmit() {
    if (!this.forgotPasswordForm.valid) {
      return;
    }

    const email = this.forgotPasswordForm.get('email').value;

    this.updateLoadScreen(true);
    this.isResetError = false;

    // the school is resolved from the Referer header and can legitimately come back
    // empty, in which case there is no account namespace to reset against
    let id = 0;
    try {
      id = await this.schoolService.getSchoolIdFromSubdomain().toPromise();
    }
    catch (err) {
      console.log(err);
    }

    if (!(id > 0)) {
      this.isResetError = true;
      this.resetMsg = "No school found. Kindly validate that the school URL is correct.";
      this.updateLoadScreen(false);
      return;
    }

    try {
      await this.resetService.forgotPassword(email).toPromise();
      this.toastr.success("Reset Password Email Sent");
      this.router.navigate(['/access/login']);
    }
    catch (err) {
      console.log(err);
      this.isResetError = true;
      this.resetMsg = "We could not send the reset email. Please try again.";
    }
    finally {
      this.updateLoadScreen(false);
    }
  }

  ngOnInit(): void {
    this.headerinfo.setPageTitle('Forgot Password');
  }

}
